module.exports = __webpack_public_path__ + "img/btn_green_resting.4643a219.webp";